import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'LogicalNDR',
  components: {
    VueElementLoading,
    BasicSelect,
    Validator,
    PageTracker,
    Multiselect
  },
  mixins: [PageTracker],
  data: function () {
    return {
      loader: '<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      srLoader: '',
      srLoader2: '',
      isLoading: false,
      BusinessConfig: '',
      BusinessConfigdata: {
        value: "",
        text: ""
      },
      BusinessConfigArray: [],
      ParentNDR: '',
      ParentNDRdata: {
        value: "",
        text: ""
      },
      ParentNDRArray: [],
      ChildNDR: '',
      ChildNDrdata: {
        value: "",
        text: "",
        ischeck: false
      },
      ChildNDRArray: [],
      NDRuniquecode: '',
      businessconfigurationid: '',
      search: '',
      SelectedNDR: [],
      LogicalNDRArray: [],
      BusinessFlow: '',
      BusinessUnit: '',
      isActive: 0,
      checkedUnchecked: '',
      CheckedList: [],
      UnCheckedList: [],
      FinalList: [],
      userDataKey : '',
    }
  },
  computed: {
    ChildNDRArray1: function () {
      var self = this;
      return this.ChildNDRArray.filter(function (child) {
        return child.text.toLowerCase().indexOf(self.search.toLowerCase()) >= 0;
      });
    },
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.getBusinessConfigList();
  },
  methods: {
    //Get Business configuration List
    getBusinessConfig(obj) {
      this.BusinessConfigdata = obj
      this.BusinessConfig = this.BusinessConfigdata.text
      this.businessconfigurationid = this.BusinessConfigdata.value
      this.BusinessFlow = this.BusinessConfigdata.BusinessFlow
      this.BusinessUnit = this.BusinessConfigdata.BusinessUnit
      this.ParentNDRArray = [];
      this.ParentNDR = '';
      this.ParentNDRdata = {
        value: "",
        text: ""
      };
      if (this.BusinessConfig) {
        this.getParentNDRList();
      }
    },
    getBusinessConfigList() {
      this.BusinessConfigArray = [];
      this.srLoader = this.loader
      axios.post(apiUrl.api_url + 'external/businessconfig/get/list', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.BusinessConfigArrayList = response.data.data.data;
            this.BusinessConfigArrayList = this.BusinessConfigArrayList.filter(el => {
              return el.businessconfigurationid != "5";
            })
            for (let i = 0; i < this.BusinessConfigArrayList.length; i++) {
              this.BusinessConfigArray.push({
                value: this.BusinessConfigArrayList[i].businessconfigurationid,
                text: `${this.BusinessConfigArrayList[i].businessconfig}`,
                BusinessFlow: this.BusinessConfigArrayList[i].flow,
                BusinessUnit: this.BusinessConfigArrayList[i].unit,
              })
            }
            this.srLoader = ''
          } else {
            this.BusinessConfigArray = [];
            this.srLoader = '';
            this.$alertify.error(result.data.message)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //Get PArent NDR/NPR List
    getParentNDR(obj) {
      this.ParentNDRdata = obj
      this.ParentNDR = this.ParentNDRdata.text
      this.NDRuniquecode = this.ParentNDRdata.value
      this.ChildNDR = '';
      this.ChildNDrdata = {
        value: "",
        text: ""
      }
      if (this.ParentNDR) {
        this.CheckLogicalNDR();
      }
    },
    getParentNDRList() {
      this.srLoader2 = this.loader
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'external/useprocess/byBusinessconfigurationid/forDropdown',
          data: {
            "businessconfigurationid": this.businessconfigurationid
          }
        })
        .then(result => {
          if (result.data.code == 200) {
            this.ParentNDRArrayList1 = result.data.data;
            if (this.businessconfigurationid == 2) {
              this.ParentNDRArrayList1 = this.ParentNDRArrayList1.filter(el => {
                return el.uniquecode != "XBU00219";
              })
            }
            for (let i = 0; i < this.ParentNDRArrayList1.length; i++) {
              this.ParentNDRArray.push({
                value: this.ParentNDRArrayList1[i].uniquecode,
                text: `${this.ParentNDRArrayList1[i].uniquecode}-${this.ParentNDRArrayList1[i].userprocess}`,
              })
            }
            this.srLoader2 = '';
          } else {
            this.srLoader2 = '';
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //Get  Logical NDR
    CheckLogicalNDR() {
      this.LogicalNDRArray = [];
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'logicalNDR/check/by/uniquecode',
          data: {
            "BusinessConfigrationId": this.businessconfigurationid,
            "ParentUniqueCode": this.NDRuniquecode
          }
        })
        .then(result => {
          if (result.data.code == 200) {
            this.LogicalNDRArray = result.data.data;
            console.log("this.LogicalNDRArray", this.LogicalNDRArray);
            this.getChildNDRList();
          } else {
            this.$alertify.error(result.data.message)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    //Get Child NDR/NPR list and Find Logical ndr in ChildNDr
    GetChildNDR(obj) {
      this.ChildNDrdata = obj
      this.ChildNDR = this.ChildNDrdata.text
    },
    getChildNDRList() {
      this.ChildNDRArray = [];
      this.ChildNDRArrayList = [];
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'external/useprocess/byBusinessconfigurationid/forDropdown',
          data: {
            "businessconfigurationid": this.businessconfigurationid
          }
        })
        .then(result => {
          if (result.data.code == 200) {
            this.ChildNDRArrayList = result.data.data;
            if (this.businessconfigurationid == 2) {
              this.ChildNDRArrayList = this.ChildNDRArrayList.filter(el => {
                return el.uniquecode != "XBU00219";
              })
            }
            for (let i = 0; i < this.ChildNDRArrayList.length; i++) {
              this.ChildNDRArrayList[i].ischeck = true;
              if (this.LogicalNDRArray.includes(this.ChildNDRArrayList[i].uniquecode)) {
                this.ChildNDRArrayList[i].ischeck = true;
              } else {
                this.ChildNDRArrayList[i].ischeck = false;
              }
              this.ChildNDRArray.push({
                value: this.ChildNDRArrayList[i].uniquecode,
                text: `${this.ChildNDRArrayList[i].uniquecode}-${this.ChildNDRArrayList[i].userprocess}`,
                ischeck: this.ChildNDRArrayList[i].ischeck
              })
            }
          } else {
            this.ChildNDRArrayList = [];
            this.ChildNDRArray = [];
            this.$alertify.error(result.data.message)
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    CheckSelected(item) {
      if (item.ischeck == true) {
        this.UnCheckedList = this.UnCheckedList.filter(el => {
          return el.AllocatedUniqueCode != item.value;
        })
        this.CheckedList.push({
          "AllocatedUniqueCode": item.value,
          "IsActive": "1"
        })
      } else {
        this.CheckedList = this.CheckedList.filter(el => {
          return el.AllocatedUniqueCode != item.value;
        })
        this.UnCheckedList.push({
          "AllocatedUniqueCode": item.value,
          "IsActive": "0"
        })
      }
      this.FinalList = this.CheckedList.concat(this.UnCheckedList);
    },

    //Validate Business config field and parent NDR field
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.Submit();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    Submit() {
      if (this.FinalList.length == 0) {
        this.$alertify.error("Please update atleast one Logical NDR to submit")
      } else {
        this.isLoading = true;
        this.Payload = {
          "ParentUniqueCode": this.NDRuniquecode,
          "UpdatedAllocatedUniqueCode": this.FinalList,
          "BusinessUnit": this.BusinessUnit,
          "BusinessConfiguration": this.BusinessFlow,
          "BusinessConfigrationId": this.businessconfigurationid.toString(),
          "LastModifiedBy": this.localusermailid
        }
        axios({
            method: 'POST',
            url: apiUrl.api_url + 'logicalNDR/save/LogicalNDRCodes',
            data: this.Payload
          })
          .then(result => {
            if (result.data.code == 200) {
              this.isLoading = false;
              this.$alertify.success("Submitted Successfully!!");
              this.reset();
            } else {
              this.isLoading = false;
              this.$alertify.error(result.data.message)
            }
          })
      }
    },

    reset() {
      this.$validator.reset();
      this.isLoading = false;
      this.srLoader2 = '';
      this.BusinessConfig = '';
      this.BusinessConfigdata = {
        value: "",
        text: ""
      };
      this.ParentNDRArray = [];
      this.ParentNDR = '';
      this.ParentNDRdata = {
        value: "",
        text: ""
      };
      this.ChildNDR = '';
      this.ChildNDrdata = {
        value: "",
        text: "",
      };
      this.ChildNDRArray = [];
      this.search = '';
      this.SelectedNDR = [];
      this.LogicalNDRArray = [];
      this.CheckedList = [];
      this.UnCheckedList = [];
      this.FinalList = [];
      this.ChildNDRArrayList = [];
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/components/LogicalNDR/LogicalNDR.component.js